import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import DashboardHeader from '../../components/DashboardComponents/DashboardHeader/DashboardHeader';
import StatsSectionComponent from '../../components/DashboardComponents/StatsSectionComponent/StatsSectionComponent';
import { useSocket } from '../../context/SocketProvider';
import { setActiveUsers } from '../../redux/slices/ChatSlice';

import './Dashboard.scss';

export interface User {
  _id: string;
  firstName: string;
  lastName: string;
  userEmail: string;
  phoneNo: string;
  city: string;
  state: { value: string; label: string };
  role: string[];
  address?: string;
  aboutUser?: string;
  currentRole: string;
  profileImage: string;
  occupation?: string;
  subscription?: {
    id: string;
    isActive: boolean;
    leftDays: number;
  };
  isEmailVerified: boolean;
  keepPhoneNumberPrivate: boolean;
  keepEmailPrivate: boolean;
  messageNotification: boolean;
  reviews: any[];
  removeProfile?: boolean;
  gender: string;
}

function Dashboard() {
  const [user, setUser] = useState<User | null>(null);

  const socket = useSocket();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const storedUser = localStorage.getItem('user');

    if (storedUser) {
      setUser(JSON.parse(storedUser));
    } else {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    if (user) {
      socket.emit('add-user', user._id);
    }
  }, [user, socket]);

  useEffect(() => {
    socket.on('set-active', (res: any) => {
      dispatch(setActiveUsers(res.activeUsers));
    });

    return () => {
      socket.off('set-active');
    };
  }, [socket, dispatch]);

  return (
    <div className="dashboard-page main-content">
      <DashboardHeader />

      {user && (
        <main className="dashboard-content">
          <div className="dashboard-welcome">
            <div className="welcome-text">
              <span className="welcome-label">Dashboard</span>

              <h1>
                Welcome back,{' '}
                <span>
                  {user.firstName} {user.lastName}
                </span>
              </h1>

              <p>
                Manage your properties, listings and account from your
                dashboard.
              </p>
            </div>
          </div>

          <section className="dashboard-stats">
            <StatsSectionComponent />
          </section>
        </main>
      )}
    </div>
  );
}

export default Dashboard;
